var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg032Emergency = function Svg032Emergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 60 0 0v452l211 60zm-60 241h-30v-90h30zM422 196H301v60h121v30l90-60-90-60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361 166V0H110.204L241 37.368V452h120V286h-90V166z"
  })));
};
export default Svg032Emergency;